var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 15.297,
    viewBox: "0 0 24 15.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -92.835)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 92.835)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.847,100.017c-.214-.293-5.323-7.182-11.848-7.182S.366,99.723.152,100.016a.792.792,0,0,0,0,.934c.214.293,5.323,7.182,11.848,7.182s11.633-6.888,11.848-7.181A.791.791,0,0,0,23.847,100.017ZM12,106.549c-4.806,0-8.969-4.572-10.2-6.066,1.231-1.5,5.384-6.065,10.2-6.065s8.968,4.571,10.2,6.066C20.97,101.98,16.816,106.549,12,106.549Z",
    transform: "translate(0 -92.835)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.253 95.736)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.469,154.725a4.747,4.747,0,1,0,4.747,4.747A4.753,4.753,0,0,0,159.469,154.725Zm0,7.912a3.165,3.165,0,1,1,3.165-3.165A3.168,3.168,0,0,1,159.469,162.637Z",
    transform: "translate(-154.722 -154.725)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.1cf18abc055676298eca0b47c9432f27.svg";
export { ForwardRef as ReactComponent };